<template>
  <div class="medical-guide-page">
    <header class="page-header">
      <div class="container">
        <div class="breadcrumb-section">
          <h2 class="current-category-title">就医指南</h2>
        </div>
      </div>
    </header>

    <div class="container">
      <aside class="sidebar">
        <div class="sidebar-section">
          <ul class="category-list">
            <li v-for="(item, index) in guideItems" :key="index" class="tree-item">
              <div class="tree-row">
                <span class="expand-icon empty"></span>
                <a href="#" @click.prevent="selectGuide(index, item)" 
                   :class="{ active: activeTab === index }">
                  {{ item.title }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </aside>

      <main class="main-layout">
        <div class="guide-content" v-if="currentGuide">
          <h1 class="guide-title">{{ currentGuide.title }}</h1>
          <div class="guide-image-wrapper">
            <img :src="currentGuide.image" :alt="currentGuide.title" class="guide-image" />
          </div>
        </div>
        <div v-else class="loading-state">
          加载中...
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import jyzlsjhrImg from '@/assets/images/jyzlsjhr.jpg'
import jtzlImg from '@/assets/images/jtzl.jpg'

export default {
  name: 'MedicalGuide',
  data() {
    return {
      activeTab: 0,
      guideItems: [
         { title: '交通指南', image: jtzlImg },
        { title: '三甲互认', image: jyzlsjhrImg }       
      ],
      currentGuide: null
    }
  },
  mounted() {
    // 根据 URL 参数设置默认高亮选项
    const tabParam = this.$route.query.tab
    if (tabParam) {
      const index = this.guideItems.findIndex(item => item.title === tabParam)
      if (index !== -1) {
        this.selectGuide(index, this.guideItems[index])
      } else {
        this.selectGuide(0, this.guideItems[0])
      }
    } else {
      if (this.guideItems.length > 0) {
        this.selectGuide(0, this.guideItems[0])
      }
    }
  },
  methods: {
    selectGuide(index, item) {
      this.activeTab = index
      this.currentGuide = item
    }
  }
}
</script>

<style lang="less" scoped>
.medical-guide-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  position: sticky;
  top: 198px;
  z-index: 150;
  background: white;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .breadcrumb-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    a {
      color: #4ecdc4;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    span {
      margin: 0 8px;
      color: #999;
    }
  }

  .current-category-title {
    font-size: 36px;
    font-weight: bold;
    color: #4ecdc4;
    margin: 0;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
  display: flex;
  gap: 30px;
}

.sidebar {
  width: 300px;
  flex-shrink: 0;
  position: sticky;
  top: 175px;
  align-self: flex-start;
}

.sidebar-section {
  background: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li.tree-item {
    border-bottom: 1px dashed #eee;

    &:last-child {
      border-bottom: none;
    }

    .tree-row {
      display: flex;
      align-items: center;
      padding: 6px 0;

      .expand-icon {
        cursor: pointer;
        font-size: 8px;
        width: 12px;
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
        color: #4ecdc4;

        &.empty {
          cursor: default;
          color: transparent;
        }
      }

      a {
        flex: 1;
        font-size: 14px;
        color: #666;
        text-decoration: none;

        &:hover, &.active {
          color: #4ecdc4;
          font-weight: bold;
        }
      }
    }
  }
}

.main-layout {
  flex: 1;
}

.loading-state {
  text-align: center;
  padding: 80px 0;
  color: #999;
  font-size: 16px;
}

.guide-content {
  flex: 1;
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .guide-title {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  .guide-image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;

    .guide-image {
      max-width: 100%;
      height: auto;
      border-radius: 8px;
    }
  }
}
</style>